import {
  Box,
  Icon,
  SimpleGrid,
  useColorModeValue,
  VStack,
  HStack,
  Heading,
  Text,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Card,
  Flex,
  Badge,
  Select,
  Image,
} from "@chakra-ui/react";
import axios from 'axios';
import { BASE_URL } from 'config/api';
import { useNavigate } from "react-router-dom";
import LoadingSpinner from 'components/LoadingSpinner';
import { usePermissions } from "../../../hooks/usePermissions";
import PermissionWrapper from "../../../components/PermissionWrapper";

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React, { useEffect, useRef, useState } from "react";
import {
  MdAddTask,
  MdOutlineFireTruck,
  MdExplore,
  MdOutlineMedicalInformation,
  MdOutlineMedicalServices,
  MdCancel,
  MdAccessTime,
  MdPhone,
  MdTimer,
  MdCheckCircle,
  MdLocalHospital,
  MdTrendingUp,
  MdInfo,
  MdRoute,
  MdPerson,
} from "react-icons/md";
import ambulanceIcon from "assets/img/dashboards/OMNIDOC.png";
import urgent from "assets/img/icons/Dashboard-icon/urgent.png";
import Type_urg from "assets/img/icons/Dashboard-icon/Type_urg.png";
import totalMissionsImg from "assets/img/tableau/misson.png";
import ambulanceStatsImg from "assets/img/tableau/ambulance.png";
import phoneIcon from "assets/img/icons/Dashboard-icon/phoneIcon.png"
import pulseIcon from "assets/img/icons/Dashboard-icon/pulse.png";
import shieldTickIcon from "assets/img/icons/Dashboard-icon/shield-tick.png";
import crossCircleIcon from "assets/img/icons/Dashboard-icon/cross-circle.png";
import config from "config/api";
import GoogleMapsLoader, { useGoogleMaps } from "components/GoogleMapsLoader";

export default function UserReports() {
  const mapRef = useRef(null);
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const [mapLoaded, setMapLoaded] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const navigate = useNavigate();
  const [markers, setMarkers] = useState([]);
  const [map, setMap] = useState(null);
  const [stats, setStats] = useState({
    missionsCreees: 0,
    missionsEnCours: 0,
    missionsTerminees: 0,
    missionsAnnulees: 0,
    medecins: 0,
    infirmiers: 0,
    ambulanciers: 0,
    ambulances: 0,
    tempsMoyenIntervention: '00:00',
    dureeTotaleMoyenne: '00:00',
    delaiPriseEnCharge: '00:00',
    etaMoyenAmbulances: '00:00',
    urgencesVitales: 0,
    arretCardiaque: 0,
    avc: 0,
    trauma: 0
  });
  const markerAnimationRefs = useRef([]);
  const markerObjectsRef = useRef(new Map());
  const lastMapInstanceRef = useRef(null);
  const { loaded: isGoogleMapsLoaded } = useGoogleMaps();

  // États pour les filtres
  const [ambulanceFilter, setAmbulanceFilter] = useState('tous'); // 'tous', 'disponibles', 'intervention', 'maintenance'
  const [equipeFilter, setEquipeFilter] = useState('tous'); // 'tous', 'medecins', 'infirmiers', 'disponibles', 'intervention'

  // État pour les métriques du dashboard
  const [dashboardMetrics, setDashboardMetrics] = useState({
    appelsRecus: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    missionsEnCours: { valeur: 0 },
    missionsTerminees: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    missionsAnnulees: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    dureeTotaleMoyenneMission: { valeur: 0, unite: 'minutes' },
    delaiMoyenAffectation: { valeur: 0, unite: 'minutes' },
    delaiMoyenIntervention: { valeur: 0, unite: 'minutes' },
    delaiMoyenSurSite: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0, unite: 'minutes' }
  });

  // État pour la période sélectionnée
  const [selectedPeriod, setSelectedPeriod] = useState('aujourdhui');

  // État pour la ville sélectionnée
  const [selectedVille, setSelectedVille] = useState('tous');

  // État pour la liste des villes
  const [villes, setVilles] = useState([]);

  // État pour les données de taux d'urgence
  const [urgenceData, setUrgenceData] = useState({
    totalMissions: 0,
    tauxUrgence: [],
    topCauses: []
  });

  // État pour les ambulances
  const [ambulancesData, setAmbulancesData] = useState({
    total: 0,
    ambulances: []
  });

  // État pour les équipes médicales
  const [equipeMedicaleData, setEquipeMedicaleData] = useState({
    medecins: {
      total: 0,
      liste: []
    },
    infirmiers: {
      total: 0,
      liste: []
    },
    ambulanciers: {
      total: 0,
      liste: []
    }
  });

  // État pour les statistiques par type de mission
  const [missionTypeStats, setMissionTypeStats] = useState({
    total: { valeur: 0, evolution: 0 },
    teleconsultation: { valeur: 0, evolution: 0 },
    consultationDomicile: { valeur: 0, evolution: 0 },
    acteInfirmier: { valeur: 0, evolution: 0 },
    ambulance: { valeur: 0, evolution: 0 },
    TAR: { valeur: 0, evolution: 0 },
    TAS: { valeur: 0, evolution: 0 }
  });

  // État pour le taux de performance global
  const [performanceData, setPerformanceData] = useState({
    tauxPerformanceGlobal: 0
  });

  // Utiliser le hook des permissions
  const { hasPermission, user } = usePermissions();

  // Vérifier la session via le cookie httpOnly `auth_token`
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Le backend lit le cookie auth_token
        const response = await axios.get(`${BASE_URL}/token/token`, {
          withCredentials: true,
        });

        if (!response.data.valid) {
          navigate('/auth/sign-in');
          return;
        }

        // Vérifier le rôle à partir de l'utilisateur chargé par usePermissions (si disponible)
        if (user) {
          const userRole = user.rôle || user['rÃ´le'] || user.role;
          if (
            userRole !== 'admin' &&
            userRole !== 'régulateur' &&
            userRole !== 'rÃ©gulateur' &&
            userRole !== 'médecin regulateur' &&
            userRole !== 'medecin regulateur'
          ) {
            navigate('/auth/sign-in');
            return;
          }
        }

        // Si tout est ok, on charge les véhicules
        fetchVehicles();
      } catch (error) {
        console.error("Erreur:", error);
        navigate('/auth/sign-in');
      }
    };

    checkSession();
    // on dépend de `user` car il peut arriver un peu après via usePermissions
  }, [navigate, user]);

  // Function to fetch vehicle location from Navixy
  const fetchVehicleLocation = async (trackerId) => {
    try {
      const data = {
        // Utiliser le hash depuis la config (variable d'environnement)
        hash: config.navixy.hash,
        tracker_id: trackerId,
      };

      const response = await axios.post(
        `${config.navixy.apiUrl}/tracker/get_state`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          // IMPORTANT : ne jamais envoyer les cookies / credentials vers l'API Navixy
          // pour éviter l'erreur CORS "credentials mode is include"
          withCredentials: false,
        }
      );

      if (response.data?.state?.gps?.location) {
        return {
          lat: response.data.state.gps.location.lat,
          lng: response.data.state.gps.location.lng
        };
      }

      // Si pas de nouvelle position, chercher la dernière position connue dans le tableau vehicles
      const vehicle = vehicles.find(v => v.tracker === trackerId);
      if (vehicle && vehicle.position) {
        return vehicle.position;
      }

      // Si aucune position n'est trouvée, retourner la position par défaut
      return {
        lat: 33.5939313,
        lng: -7.6387418
      };
    } catch (error) {
      // En cas d'erreur 403 ou autre, chercher la dernière position connue dans le tableau vehicles
      const vehicle = vehicles.find(v => v.tracker === trackerId);
      if (vehicle && vehicle.position) {
        return vehicle.position;
      }

      // Si aucune position n'est trouvée, retourner la position par défaut
      return {
        lat: 33.5939313,
        lng: -7.6387418
      };
    }
  };

  // Function to update vehicle locations
  const updateVehicleLocations = async () => {
    try {
      const updatedVehicles = await Promise.all(vehicles.map(async (vehicle) => {
        const location = await fetchVehicleLocation(vehicle.tracker);
        return {
          ...vehicle,
          position: location
        };
      }));
      setVehicles(updatedVehicles);
    } catch (error) {
      // Gérer l'erreur silencieusement
    }
  };

  // Set up interval for location updates
  useEffect(() => {
    const intervalId = setInterval(updateVehicleLocations, 10000); // Update every 5 seconds

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [vehicles]); // Re-run effect when vehicles change

  // Function to fetch user data
  const fetchUserData = async (userId) => {
    try {
      // Si userId est null, retourner des valeurs par défaut
      if (!userId) {
        return {
          nom: 'Non assigné',
          prenom: ''
        };
      }

      const response = await axios.get(`${BASE_URL}/users/${userId}`, {
        withCredentials: true,
      });

      return {
        nom: response.data.nom || 'Inconnu',
        prenom: response.data.prenom || 'Inconnu'
      };
    } catch (error) {
      console.error(`Error fetching user data for ID ${userId}:`, error);
      return {
        nom: 'Inconnu',
        prenom: 'Inconnu'
      };
    }
  };

  // Function to fetch vehicles data
  const fetchVehicles = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/vehicules`, {
        withCredentials: true,
      });

      //console.log('Raw API Response:', response.data);

      // Transform and store the required data
      const formattedVehicles = await Promise.all(response.data.map(async (vehicle) => {
        try {
          const userInfo = await fetchUserData(vehicle.user_id);
          const location = await fetchVehicleLocation(vehicle.tracker_id);

          return {
            id: vehicle.id,
            user_id: vehicle.user_id,
            nom: userInfo.nom,
            prenom: userInfo.prenom,
            imatricule: vehicle.immatriculation,
            statut: vehicle.statut,
            tracker: vehicle.tracker_id,
            position: location
          };
        } catch (error) {
          console.error(`Error processing vehicle ${vehicle.id}:`, error);
          return null;
        }
      }));

      // Filter out any null values from failed processing
      const validVehicles = formattedVehicles.filter(vehicle => vehicle !== null);
      //console.log('Formatted Vehicles with locations:', validVehicles);

      setVehicles(validVehicles);
    } catch (error) {
      console.error('Error fetching vehicles:', error);
      // Optionally show error to user
      if (error.response?.status === 401) {
        navigate('/auth/sign-in');
      }
    }
  };

  useEffect(() => {
    if (isGoogleMapsLoaded && mapRef.current && !mapRef.current._google_map_instance) {
      const newMap = new window.google.maps.Map(mapRef.current, {
        center: { lat: 33.5939313, lng: -7.6387418 },
        zoom: 12,
        styles: [
          { "elementType": "geometry", "stylers": [{ "color": "#ebe3cd" }] },
          { "elementType": "labels.text.fill", "stylers": [{ "color": "#523735" }] },
          { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f1e6" }] },
          { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#c9b2a6" }] },
          { "featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{ "color": "#dcd2be" }] },
          { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#ae9e90" }] },
          { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#93817c" }] },
          { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#006133" }] },
          { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#447530" }] },
          { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#f5f1e6" }] },
          { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#fdfcf8" }] },
          { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#f8c967" }] },
          { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#e9bc62" }] },
          { "featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{ "color": "#e98d58" }] },
          { "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{ "color": "#db8555" }] },
          { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#806b63" }] },
          { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{ "color": "#8f7d77" }] },
          { "featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ebe3cd" }] },
          { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#b9d3c2" }] },
          { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#92998d" }] }
        ],
      });
      setMap(newMap);
      setMapLoaded(true);
      mapRef.current._google_map_instance = newMap;
      console.log('Google Map initialisée !');
    }
    return () => {
      setMapLoaded(false);
      if (mapRef.current && mapRef.current._google_map_instance) {
        delete mapRef.current._google_map_instance;
      }
    };
  }, [isGoogleMapsLoaded]);

  // Create or update markers when vehicles change
  useEffect(() => {
    if (!mapLoaded || !map) {
      // If map is not ready, or becomes unready, clear out existing markers from the map and refs
      markerObjectsRef.current.forEach(marker => marker.setMap(null));
      markerObjectsRef.current.clear();
      setMarkers([]);
      if (lastMapInstanceRef.current) lastMapInstanceRef.current = null;
      markerAnimationRefs.current.forEach(ref => { if (ref && ref.id) cancelAnimationFrame(ref.id); });
      markerAnimationRefs.current = [];
      return;
    }

    // If the map instance has changed, we need to clear and recreate all markers for the new map.
    if (map !== lastMapInstanceRef.current) {
      markerObjectsRef.current.forEach(marker => marker.setMap(null));
      markerObjectsRef.current.clear();
      lastMapInstanceRef.current = map;
      // Animation refs will be rebuilt below based on the new set of markers for the new map
      markerAnimationRefs.current.forEach(ref => { if (ref && ref.id) cancelAnimationFrame(ref.id); });
      markerAnimationRefs.current = [];
    }

    const newMarkerStateArray = [];
    const currentVehicleIds = new Set();
    const newAnimationRefs = [];

    const ambulanceMarkerIcon = {
      url: ambulanceIcon,
      scaledSize: new window.google.maps.Size(50, 50),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(30, 30)
    };

    vehicles.forEach((vehicle) => {
      currentVehicleIds.add(vehicle.id);
      let marker = markerObjectsRef.current.get(vehicle.id);
      let animationRef = markerAnimationRefs.current.find(ref => ref && ref.vehicleId === vehicle.id);


      if (!marker) {
        // Marker doesn't exist, create it
        marker = new window.google.maps.Marker({
          position: vehicle.position, // Set initial position
          map: map,
          title: `${vehicle.nom} ${vehicle.prenom}`,
          icon: ambulanceMarkerIcon,
        });
        markerObjectsRef.current.set(vehicle.id, marker);

        // Add InfoWindow listener only once on creation
        const contentString = `
          <div>
            <h3 style="margin: 0 0 5px 0; color: #2B3674;">${vehicle.nom} ${vehicle.prenom}</h3>
            <p style="margin: 0 0 5px 0;"><strong>Immatriculation:</strong> ${vehicle.imatricule}</p>
            <p style="margin: 0 0 5px 0;"><strong>Statut:</strong> ${vehicle.statut}</p>
            <p style="margin: 0 0 5px 0;"><strong>Tracker ID:</strong> ${vehicle.tracker}</p>
          </div>
        `;
        const infoWindow = new window.google.maps.InfoWindow({
          content: contentString,
          maxWidth: 300
        });
        marker.addListener("click", () => {
          infoWindow.open(map, marker);
        });
        animationRef = { vehicleId: vehicle.id, id: null }; // Create new animation ref
      }
      else if (!animationRef) { // Marker exists, but no animation ref (e.g. after map change)
        animationRef = { vehicleId: vehicle.id, id: null };
      }

      newMarkerStateArray.push(marker);
      newAnimationRefs.push(animationRef);
    });

    // Remove markers for vehicles that are no longer present
    const oldAnimationRefs = [...markerAnimationRefs.current];
    markerObjectsRef.current.forEach((marker, vehicleId) => {
      if (!currentVehicleIds.has(vehicleId)) {
        marker.setMap(null); // Remove from map
        markerObjectsRef.current.delete(vehicleId);
        // Cancel and remove its animation ref
        const refToRemove = oldAnimationRefs.find(ref => ref && ref.vehicleId === vehicleId);
        if (refToRemove && refToRemove.id) {
          cancelAnimationFrame(refToRemove.id);
        }
      }
    });

    // Update the `markers` state which is used by the animation hook
    // This ensures the animation hook gets an array of STABLE marker instances
    setMarkers(newMarkerStateArray);
    markerAnimationRefs.current = newAnimationRefs;

  }, [vehicles, mapLoaded, map]);

  // Animate marker positions when vehicles array indicates a change in position
  useEffect(() => {
    if (!mapLoaded || !map || !markers.length || !vehicles.length || markers.length !== vehicles.length) {
      return;
    }

    vehicles.forEach((vehicle, index) => {
      const marker = markers[index];
      if (!marker) return;

      const oldPosition = marker.getPosition();
      const newGPosition = new window.google.maps.LatLng(vehicle.position.lat, vehicle.position.lng);

      // Cancel any existing animation for this marker
      if (markerAnimationRefs.current[index] && markerAnimationRefs.current[index].id) {
        cancelAnimationFrame(markerAnimationRefs.current[index].id);
        markerAnimationRefs.current[index].id = null;
      }

      const fromLat = oldPosition.lat();
      const fromLng = oldPosition.lng();
      const toLat = newGPosition.lat();
      const toLng = newGPosition.lng();

      // Si la position est la même ou très proche, ne pas animer
      if (Math.abs(fromLat - toLat) < 0.00001 && Math.abs(fromLng - toLng) < 0.00001) {
        return;
      }

      // Calculer la distance entre les points
      const distance = Math.sqrt(
        Math.pow(toLat - fromLat, 2) + Math.pow(toLng - fromLng, 2)
      );

      // Si la distance est trop grande, déplacer directement sans animation
      if (distance > 0.1) {
        marker.setPosition(newGPosition);
        return;
      }

      const duration = 1000; // 1 seconde d'animation
      let startTime = null;

      const animateMarker = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Utiliser une fonction d'easing pour une animation plus fluide
        const easeProgress = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        const currentLat = fromLat + (toLat - fromLat) * easeProgress;
        const currentLng = fromLng + (toLng - fromLng) * easeProgress;

        marker.setPosition(new window.google.maps.LatLng(currentLat, currentLng));

        if (progress < 1) {
          markerAnimationRefs.current[index].id = requestAnimationFrame(animateMarker);
        } else {
          marker.setPosition(newGPosition);
          markerAnimationRefs.current[index].id = null;
        }
      };

      if (!markerAnimationRefs.current[index]) {
        markerAnimationRefs.current[index] = { id: null };
      }
      markerAnimationRefs.current[index].id = requestAnimationFrame(animateMarker);
    });

    return () => {
      markerAnimationRefs.current.forEach(ref => {
        if (ref && ref.id) {
          cancelAnimationFrame(ref.id);
          ref.id = null;
        }
      });
    };
  }, [vehicles, mapLoaded, map, markers]);

  // Fonction pour convertir des minutes en format MM:SS
  const minutesToMMSS = (minutes) => {
    if (!minutes && minutes !== 0) return '00:00';
    const mins = Math.floor(minutes);
    const secs = Math.floor((minutes - mins) * 60);
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  // Fonction pour formater le pourcentage de différence
  const formatEvolution = (differencePourcentage) => {
    if (!differencePourcentage && differencePourcentage !== 0) return { text: '0%', type: 'stable', isPositive: false };
    const isPositive = differencePourcentage > 0;
    const absValue = Math.abs(differencePourcentage);
    return {
      text: `${isPositive ? '+' : ''}${absValue.toFixed(0)}%`,
      type: isPositive ? 'augmentation' : differencePourcentage < 0 ? 'diminution' : 'stable',
      isPositive
    };
  };

  // Fonction pour obtenir le texte de comparaison selon la période
  const getComparisonText = (period) => {
    switch (period) {
      case 'aujourdhui':
        return 'vs hier';
      case 'mois':
        return 'vs mois dernier';
      case 'trimestre':
        return 'vs trimestre dernier';
      case 'annee':
        return 'vs année dernière';
      default:
        return 'vs hier';
    }
  };

  // Fonction pour obtenir le texte de période pour les labels
  const getPeriodLabel = (period) => {
    switch (period) {
      case 'aujourdhui':
        return 'Aujourd\'hui';
      case 'mois':
        return 'Ce mois';
      case 'trimestre':
        return 'Ce trimestre';
      case 'annee':
        return 'Cette année';
      default:
        return 'Aujourd\'hui';
    }
  };

  // Fonction pour obtenir le texte "Depuis" selon la période
  const getSinceText = (period) => {
    switch (period) {
      case 'aujourdhui':
        return 'Depuis 00:00 AM';
      case 'mois':
        return 'Depuis début du mois';
      case 'trimestre':
        return 'Depuis début du trimestre';
      case 'annee':
        return 'Depuis début de l\'année';
      default:
        return 'Depuis 00:00 AM';
    }
  };

  // Fonction pour obtenir le titre "Appels Reçus" selon la période
  const getAppelsTitle = (period) => {
    switch (period) {
      case 'aujourdhui':
        return 'Appels Reçus Aujourd\'hui';
      case 'mois':
        return 'Appels Reçus Ce Mois';
      case 'trimestre':
        return 'Appels Reçus Ce Trimestre';
      case 'annee':
        return 'Appels Reçus Cette Année';
      default:
        return 'Appels Reçus Aujourd\'hui';
    }
  };

  // Fonction pour récupérer la liste des villes depuis l'API
  const fetchVilles = async () => {
    try {
      // Récupérer les villes depuis l'endpoint dédié
      const response = await axios.get(`${BASE_URL}/tableaudebord/villes`, {
        withCredentials: true,
      });

      if (response.data && Array.isArray(response.data)) {
        // Trier les villes par ordre alphabétique
        const villesTriees = [...response.data].sort();

        setVilles(villesTriees);
        console.log('Villes récupérées:', villesTriees);
      } else {
        console.warn('No villes found in API response:', response.data);
        // En cas de réponse vide, utiliser une liste par défaut
        setVilles(['Casablanca', 'Rabat', 'Marrakech', 'Tanger', 'Fès', 'Agadir']);
      }
    } catch (error) {
      console.error('Error fetching villes:', error);
      if (error.response) {
        console.error('API Error Response:', error.response.data);
        console.error('API Error Status:', error.response.status);
      }
      // En cas d'erreur, utiliser une liste par défaut
      setVilles(['Casablanca', 'Rabat', 'Marrakech', 'Tanger', 'Fès', 'Agadir']);
    }
  };

  // Fonction pour récupérer les métriques du dashboard depuis l'API
  const fetchDashboardMetrics = async (period = 'aujourdhui', ville = 'tous') => {
    try {
      const url = `${BASE_URL}/tableaudebord`;

      const params = { period };
      if (ville && ville !== 'tous') {
        params.ville = ville;
      }

      // Log de l'URL complète pour déboguer
      const queryString = new URLSearchParams(params).toString();
      const fullUrl = `${url}?${queryString}`;
      console.log(`[Dashboard Metrics] Full URL: ${fullUrl}`);
      console.log(`[Dashboard Metrics] Params:`, params);

      const response = await axios.get(url, {
        params,
        withCredentials: true,
      });

      console.log(`API Response for period ${period}:`, response.data);

      if (response.data && response.data.metriques) {
        setDashboardMetrics(response.data.metriques);
        console.log('Dashboard metrics updated:', response.data.metriques);
      } else {
        console.warn('No metriques found in API response:', response.data);
      }
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      if (error.response) {
        console.error('API Error Response:', error.response.data);
        console.error('API Error Status:', error.response.status);
      }
      // En cas d'erreur, on garde les valeurs par défaut
    }
  };

  // Fonction pour récupérer les données de taux d'urgence depuis l'API
  const fetchUrgenceData = async (period = 'aujourdhui', ville = 'tous') => {
    try {
      const url = `${BASE_URL}/tableaudebord/taux-urgence`;

      const params = { period };
      if (ville && ville !== 'tous') {
        params.ville = ville;
      }

      // Log de l'URL complète pour déboguer
      const queryString = new URLSearchParams(params).toString();
      const fullUrl = `${url}?${queryString}`;
      console.log(`[Urgence Data] Full URL: ${fullUrl}`);
      console.log(`[Urgence Data] Params:`, params);

      const response = await axios.get(url, {
        params,
        withCredentials: true,
      });

      console.log(`API Response for urgence data (period ${period}):`, response.data);

      if (response.data) {
        setUrgenceData({
          totalMissions: response.data.totalMissions || 0,
          tauxUrgence: response.data.tauxUrgence || [],
          topCauses: response.data.topCauses || []
        });
        console.log('Urgence data updated:', response.data);
      }
    } catch (error) {
      console.error('Error fetching urgence data:', error);
      if (error.response) {
        console.error('API Error Response:', error.response.data);
        console.error('API Error Status:', error.response.status);
      }
      // En cas d'erreur, on garde les valeurs par défaut
    }
  };

  // Fonction pour récupérer les données des ambulances depuis l'API
  const fetchAmbulancesData = async (ville = 'tous') => {
    try {
      const url = `${BASE_URL}/tableaudebord/ambulance`;
      console.log(`Fetching ambulances data, ville: ${ville}`);

      const params = {};
      if (ville && ville !== 'tous') {
        params.ville = ville;
      }

      const response = await axios.get(url, {
        params,
        withCredentials: true,
      });

      console.log('API Response for ambulances:', response.data);

      if (response.data) {
        setAmbulancesData({
          total: response.data.total || 0,
          ambulances: response.data.ambulances || []
        });
        console.log('Ambulances data updated:', response.data);
      }
    } catch (error) {
      console.error('Error fetching ambulances data:', error);
      if (error.response) {
        console.error('API Error Response:', error.response.data);
        console.error('API Error Status:', error.response.status);
      }
      // En cas d'erreur, on garde les valeurs par défaut
    }
  };

  // Fonction pour récupérer les données des équipes médicales depuis l'API
  const fetchEquipeMedicaleData = async (period = 'aujourdhui', ville = 'tous') => {
    try {
      const url = `${BASE_URL}/tableaudebord/equipe-medicale`;
      console.log(`Fetching equipe medicale data with period: ${period}, ville: ${ville}`);

      const params = { period };
      if (ville && ville !== 'tous') {
        params.ville = ville;
      }

      const response = await axios.get(url, {
        params,
        withCredentials: true,
      });

      console.log(`API Response for equipe medicale (period ${period}):`, response.data);

      if (response.data) {
        setEquipeMedicaleData({
          medecins: {
            total: response.data.medecins?.total || 0,
            liste: response.data.medecins?.liste || []
          },
          infirmiers: {
            total: response.data.infirmiers?.total || 0,
            liste: response.data.infirmiers?.liste || []
          },
          ambulanciers: {
            total: response.data.ambulanciers?.total || 0,
            liste: response.data.ambulanciers?.liste || []
          }
        });
        console.log('Equipe medicale data updated:', response.data);
      }
    } catch (error) {
      console.error('Error fetching equipe medicale data:', error);
      if (error.response) {
        console.error('API Error Response:', error.response.data);
        console.error('API Error Status:', error.response.status);
      }
      // En cas d'erreur, on garde les valeurs par défaut
    }
  };

  // Fonction pour récupérer les stats de missions (total + par type) depuis l'API tableau de bord
  const fetchMissionTypeStats = async (period = 'aujourdhui', ville = 'tous') => {
    try {
      const url = `${BASE_URL}/tableaudebord/mission`;

      const params = { period };
      if (ville && ville !== 'tous') {
        params.ville = ville;
      }

      const queryString = new URLSearchParams(params).toString();
      const fullUrl = `${url}?${queryString}`;
      console.log(`[Mission Type Stats] Full URL: ${fullUrl}`);
      console.log('[Mission Type Stats] Params:', params);

      const response = await axios.get(url, {
        params,
        withCredentials: true,
      });

      console.log('[Mission Type Stats] API response:', response.data);

      if (response.data && response.data.metriques) {
        const metriques = response.data.metriques;

        setMissionTypeStats({
          total: {
            valeur: metriques.totalMissions?.valeur || 0,
            evolution: metriques.totalMissions?.differencePourcentage || 0,
          },
          TAR: {
            valeur: metriques.TAR?.valeur || 0,
            evolution: metriques.TAR?.differencePourcentage || 0,
          },
          TAS: {
            valeur: metriques.TAS?.valeur || 0,
            evolution: metriques.TAS?.differencePourcentage || 0,
          },
        });
      } else {
        console.warn('[Mission Type Stats] No metriques in API response:', response.data);
      }
    } catch (error) {
      console.error('[Mission Type Stats] Error fetching mission stats:', error);
      if (error.response) {
        console.error('[Mission Type Stats] API Error Response:', error.response.data);
        console.error('[Mission Type Stats] API Error Status:', error.response.status);
      }
      // En cas d'erreur, on garde les valeurs actuelles
    }
  };

  // Fonction pour récupérer les données de performance depuis l'API analyses/perf
  const fetchPerformanceData = async (period = 'aujourdhui', ville = 'tous') => {
    try {
      const url = `${BASE_URL}/analyses/perf`;

      const params = { periode: period };
      if (ville && ville !== 'tous') {
        params.ville = ville;
      }

      console.log(`[Performance Data] Fetching with period: ${period}, ville: ${ville}`);

      const response = await axios.get(url, {
        params,
        withCredentials: true,
      });

      console.log('[Performance Data] API response:', response.data);

      if (response.data) {
        setPerformanceData({
          tauxPerformanceGlobal: response.data.taux_performance_global || 0
        });
      }
    } catch (error) {
      console.error('[Performance Data] Error fetching performance data:', error);
      // En cas d'erreur, on garde les valeurs actuelles
    }
  };

  // Fonction pour récupérer les statistiques
  const fetchStats = async () => {
    try {
      const [missionsRes, usersRes, vehiclesRes] = await Promise.all([
        axios.get(`${BASE_URL}/missions`, {
          withCredentials: true,
        }),
        axios.get(`${BASE_URL}/users`, {
          withCredentials: true,
        }),
        axios.get(`${BASE_URL}/vehicules`, {
          withCredentials: true,
        })
      ]);

      // Calculer les statistiques des missions
      const missions = missionsRes.data;
      // Filtrer les missions par statut (gérer les variations possibles)
      const missionsCreees = missions.filter(m =>
        m.statut === 'créée' || m.statut === 'creee' || m.statut === 'cree' || m.statut === 'created'
      ).length;
      const missionsEnCours = missions.filter(m =>
        m.statut === 'en cours' || m.statut === 'en_cours' || m.statut === 'in_progress'
      ).length;
      const missionsTerminees = missions.filter(m =>
        m.statut === 'terminée' || m.statut === 'terminee' || m.statut === 'termine' || m.statut === 'completed'
      ).length;
      const missionsAnnulees = missions.filter(m =>
        m.statut === 'annulée' || m.statut === 'annulee' || m.statut === 'annule' || m.statut === 'cancelled'
      ).length;

      // Fonction pour convertir une durée en format HH:MM:SS en minutes
      const parseTimeToMinutes = (timeString) => {
        if (!timeString) return 0;
        const parts = timeString.split(':');
        if (parts.length >= 2) {
          const hours = parseInt(parts[0]) || 0;
          const minutes = parseInt(parts[1]) || 0;
          return hours * 60 + minutes;
        }
        return 0;
      };

      // Fonction pour convertir des minutes en format MM:SS
      const minutesToTime = (minutes) => {
        const mins = Math.floor(minutes);
        const secs = Math.floor((minutes - mins) * 60);
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      };

      // Calculer le temps moyen d'intervention (temps entre départ et fin)
      const missionsAvecTemps = missions.filter(m =>
        m.temps_depart && m.temps_fin &&
        (m.statut === 'terminée' || m.statut === 'terminee' || m.statut === 'termine' || m.statut === 'completed')
      );
      let tempsMoyenIntervention = '12:34'; // Valeur par défaut
      if (missionsAvecTemps.length > 0) {
        const tempsInterventions = missionsAvecTemps.map(m => {
          const depart = parseTimeToMinutes(m.temps_depart);
          const fin = parseTimeToMinutes(m.temps_fin);
          return fin - depart;
        }).filter(t => t > 0);
        if (tempsInterventions.length > 0) {
          const moyenne = tempsInterventions.reduce((a, b) => a + b, 0) / tempsInterventions.length;
          tempsMoyenIntervention = minutesToTime(moyenne);
        }
      }

      // Calculer la durée totale moyenne (temps_total)
      const missionsAvecDuree = missions.filter(m =>
        m.temps_total &&
        (m.statut === 'terminée' || m.statut === 'terminee' || m.statut === 'termine' || m.statut === 'completed')
      );
      let dureeTotaleMoyenne = '42:18'; // Valeur par défaut
      if (missionsAvecDuree.length > 0) {
        const durees = missionsAvecDuree.map(m => parseTimeToMinutes(m.temps_total)).filter(d => d > 0);
        if (durees.length > 0) {
          const moyenne = durees.reduce((a, b) => a + b, 0) / durees.length;
          dureeTotaleMoyenne = minutesToTime(moyenne);
        }
      }

      // Calculer le délai de prise en charge (temps entre création et départ)
      const missionsAvecDelai = missions.filter(m =>
        m.date_creation && m.temps_depart &&
        (m.statut === 'terminée' || m.statut === 'terminee' || m.statut === 'termine' || m.statut === 'completed' ||
          m.statut === 'en cours' || m.statut === 'en_cours' || m.statut === 'in_progress')
      );
      let delaiPriseEnCharge = '2:47'; // Valeur par défaut
      if (missionsAvecDelai.length > 0) {
        const delais = missionsAvecDelai.map(m => {
          try {
            const dateCreation = new Date(m.date_creation);
            const tempsDepart = m.temps_depart;
            // Si temps_depart est une date complète, l'utiliser, sinon combiner avec date_creation
            let dateDepart;
            if (tempsDepart.includes('T') || tempsDepart.includes(' ')) {
              dateDepart = new Date(tempsDepart);
            } else {
              dateDepart = new Date(dateCreation.toDateString() + ' ' + tempsDepart);
            }
            const diffMs = dateDepart - dateCreation;
            return diffMs / (1000 * 60); // Convertir en minutes
          } catch (e) {
            return null;
          }
        }).filter(d => d !== null && d > 0);
        if (delais.length > 0) {
          const moyenne = delais.reduce((a, b) => a + b, 0) / delais.length;
          delaiPriseEnCharge = minutesToTime(moyenne);
        }
      }

      // ETA moyen ambulances (temps estimé d'arrivée) - utiliser une valeur par défaut pour l'instant
      const etaMoyenAmbulances = '8:15';

      // Calculer les urgences vitales
      const urgencesVitalesList = missions.filter(m =>
        m.urgence === 'vitale' || m.urgence === 'Vitale' || m.urgence_vitale === true || m.urgence_vitale === 1
      );
      const urgencesVitales = urgencesVitalesList.length;

      // Calculer les détails des urgences vitales par cause
      const arretCardiaque = missions.filter(m =>
        (m.urgence === 'vitale' || m.urgence === 'Vitale' || m.urgence_vitale === true || m.urgence_vitale === 1) &&
        (m.cause?.toLowerCase().includes('cardiaque') || m.cause?.toLowerCase().includes('arrêt') || m.cause?.toLowerCase().includes('cardiac'))
      ).length;

      const avc = missions.filter(m =>
        (m.urgence === 'vitale' || m.urgence === 'Vitale' || m.urgence_vitale === true || m.urgence_vitale === 1) &&
        (m.cause?.toLowerCase().includes('avc') || m.cause?.toLowerCase().includes('neurologique') || m.cause?.toLowerCase().includes('stroke'))
      ).length;

      const trauma = missions.filter(m =>
        (m.urgence === 'vitale' || m.urgence === 'Vitale' || m.urgence_vitale === true || m.urgence_vitale === 1) &&
        (m.cause?.toLowerCase().includes('trauma') || m.cause?.toLowerCase().includes('accident'))
      ).length;

      // Calculer les statistiques des utilisateurs
      const users = usersRes.data;
      const medecins = users.filter(u =>
        u.rôle === 'médecin' || u.rôle === 'medecin' || u.rôle === 'médecin' || u.role === 'médecin' || u.role === 'medecin'
      ).length;
      const infirmiers = users.filter(u =>
        u.rôle === 'infirmier' || u.role === 'infirmier'
      ).length;
      const ambulanciers = users.filter(u =>
        u.rôle === 'ambulancier' || u.role === 'ambulancier'
      ).length;

      // Calculer les statistiques des véhicules
      const ambulances = vehiclesRes.data.length;

      const statsData = {
        missionsCreees,
        missionsEnCours,
        missionsTerminees,
        missionsAnnulees,
        medecins,
        infirmiers,
        ambulanciers,
        ambulances,
        tempsMoyenIntervention,
        dureeTotaleMoyenne,
        delaiPriseEnCharge,
        etaMoyenAmbulances,
        urgencesVitales,
        arretCardiaque,
        avc,
        trauma
      };

      // Log pour déboguer
      console.log('Statistiques récupérées depuis la DB:', statsData);

      setStats(statsData);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  // Récupérer la liste des villes au chargement
  useEffect(() => {
    fetchVilles();
  }, []);

  // Appeler les fonctions de récupération des données quand la période ou la ville change
  useEffect(() => {
    fetchDashboardMetrics(selectedPeriod, selectedVille);
    fetchUrgenceData(selectedPeriod, selectedVille);
    fetchEquipeMedicaleData(selectedPeriod, selectedVille);
    fetchAmbulancesData(selectedVille);
    fetchMissionTypeStats(selectedPeriod, selectedVille);
    fetchPerformanceData(selectedPeriod, selectedVille);
  }, [selectedPeriod, selectedVille]);

  // Ajouter un intervalle pour rafraîchir les statistiques toutes les 5 secondes
  useEffect(() => {
    fetchStats(); // Récupérer les statistiques immédiatement
    fetchDashboardMetrics(selectedPeriod, selectedVille); // Récupérer les métriques du dashboard
    fetchUrgenceData(selectedPeriod, selectedVille); // Récupérer les données de taux d'urgence
    fetchAmbulancesData(selectedVille); // Récupérer les données des ambulances
    fetchEquipeMedicaleData(selectedPeriod, selectedVille); // Récupérer les données des équipes médicales
    fetchMissionTypeStats(selectedPeriod, selectedVille); // Récupérer les stats de missions (total + types)
    fetchPerformanceData(selectedPeriod, selectedVille); // Récupérer les données de performance
    const interval = setInterval(() => {
      fetchStats();
      fetchDashboardMetrics(selectedPeriod, selectedVille);
      fetchUrgenceData(selectedPeriod, selectedVille);
      fetchAmbulancesData(selectedVille);
      fetchEquipeMedicaleData(selectedPeriod, selectedVille);
      fetchMissionTypeStats(selectedPeriod, selectedVille);
      fetchPerformanceData(selectedPeriod, selectedVille);
    }, 5000);
    return () => clearInterval(interval);
  }, [selectedPeriod, selectedVille]);

  const bgColor = useColorModeValue('gray.50', 'gray.800');

  return (
    !isGoogleMapsLoaded ? (
      <LoadingSpinner message="Chargement de Google Maps..." size="lg" fullHeight />
    ) : (
      <>
        <style>
          {`
            @keyframes pulse {
              0%, 100% {
                opacity: 1;
                transform: translate(-50%, -50%) scale(1);
              }
              50% {
                opacity: 0.5;
                transform: translate(-50%, -50%) scale(1.5);
              }
            }
          `}
        </style>
        <Box minH="100vh" bg="linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)" pt="7%">
          <Box maxW="9xl" mx="auto" mt={12}>
            <VStack spacing={8} align="stretch">
              <Card
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
              >
                <VStack spacing="20px" align="stretch">
                  {/* En-tête */}
                  <Flex justify="space-between" align="flex-start" w="100%">
                    <VStack spacing="5px" align="flex-start" flex={1}>
                      <Text fontSize="16px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                        Indicateurs en Temps Réel
                      </Text>
                      <Text fontSize="13px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                        tableau de bord opérationnel - Vue d'ensemble
                      </Text>
                    </VStack>
                    <HStack spacing="10px">
                      <Select
                        value={selectedPeriod}
                        onChange={(e) => setSelectedPeriod(e.target.value)}
                        bg="white"
                        border="1px solid"
                        borderColor="#E5E5E5"
                        borderRadius="8px"
                        fontSize="14px"
                        fontWeight="500"
                        fontFamily="Poppins, sans-serif"
                        color="#171D28"
                        w="180px"
                        _hover={{
                          borderColor: "#459CE9"
                        }}
                        _focus={{
                          borderColor: "#459CE9",
                          boxShadow: "0 0 0 1px #459CE9"
                        }}
                      >
                        <option value="aujourdhui">Aujourd'hui</option>
                        <option value="mois">Ce mois</option>
                        <option value="trimestre">Ce trimestre</option>
                        <option value="annee">Cette année</option>
                      </Select>
                      <Select
                        value={selectedVille}
                        onChange={(e) => setSelectedVille(e.target.value)}
                        bg="white"
                        border="1px solid"
                        borderColor="#E5E5E5"
                        borderRadius="8px"
                        fontSize="14px"
                        fontWeight="500"
                        fontFamily="Poppins, sans-serif"
                        color="#171D28"
                        w="180px"
                        _hover={{
                          borderColor: "#459CE9"
                        }}
                        _focus={{
                          borderColor: "#459CE9",
                          boxShadow: "0 0 0 1px #459CE9"
                        }}
                      >
                        <option value="tous">Toutes les villes</option>
                        {villes.map((ville) => (
                          <option key={ville} value={ville}>
                            {ville}
                          </option>
                        ))}
                      </Select>
                    </HStack>
                  </Flex>

                  {/* Bandeau de statistiques par type de mission (design Figma) */}
                  <Box w="100%" border="1px solid #E5E5E5">
                    <Flex w="100%">
                      {/* Total Missions */}
                      <Box
                        flex="1"
                        bg="#FCFCFC"
                        borderRight="1px solid #E5E5E5"
                        p="20px"
                        pt="14px"
                        pb="20px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <VStack spacing="13px" align="center" w="169px">
                          <Flex w="100%" alignItems="flex-end" justifyContent="center">
                            <Flex flex="1" gap="10px" alignItems="center" justifyContent="center">
                              <Box
                                as="img"
                                src={totalMissionsImg || undefined}
                                alt="Total Missions"
                                w="32px"
                                h="32px"
                                objectFit="contain"
                              />
                              <Text
                                fontFamily="Oswald, sans-serif"
                                fontWeight="600"
                                fontSize="28px"
                                lineHeight="1.2"
                                color="#455879"
                              >
                                {missionTypeStats.total.valeur}
                              </Text>
                            </Flex>
                          </Flex>
                          <VStack spacing="6px" align="flex-start" w="100%">
                            <Text
                              fontFamily="Poppins, sans-serif"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="1.2"
                              color="#656C7A"
                              textAlign="center"
                              w="100%"
                              whiteSpace="pre-wrap"
                            >
                              Total Missions
                            </Text>
                            <Flex gap="10px" h="18px" alignItems="center" justifyContent="center" w="100%">
                              <Text
                                fontFamily="Poppins, sans-serif"
                                fontWeight="400"
                                fontSize="12px"
                                lineHeight="1.2"
                                color="#656C7A"
                              >
                                Aujourd'hui
                              </Text>
                              <Flex gap="5px" alignItems="center">
                                <Icon
                                  as={MdTrendingUp}
                                  w="12px"
                                  h="12px"
                                  color={missionTypeStats.total.evolution >= 0 ? "#29BACD" : "#F8285A"}
                                  transform={missionTypeStats.total.evolution < 0 ? "rotate(180deg)" : "none"}
                                />
                                <Text
                                  fontFamily="Poppins, sans-serif"
                                  fontWeight="500"
                                  fontSize="12px"
                                  lineHeight="12px"
                                  color={missionTypeStats.total.evolution >= 0 ? "#29BACD" : "#F8285A"}
                                >
                                  {missionTypeStats.total.evolution >= 0 ? "+" : ""}
                                  {missionTypeStats.total.evolution}% {getComparisonText(selectedPeriod)}
                                </Text>
                              </Flex>
                            </Flex>
                          </VStack>
                        </VStack>
                      </Box>
                      <Box
                        flex="1"
                        bg="#FCFCFC"
                        p="20px"
                        pt="14px"
                        pb="20px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <VStack spacing="13px" align="center" w="169px">
                          <Flex w="100%" alignItems="flex-end" justifyContent="center">
                            <Flex flex="1" gap="10px" alignItems="center" justifyContent="center">
                              <Box
                                as="img"
                                src={ambulanceStatsImg || undefined}
                                alt="Ambulance"
                                w="32px"
                                h="32px"
                                objectFit="contain"
                              />
                              <Text
                                fontFamily="Oswald, sans-serif"
                                fontWeight="600"
                                fontSize="28px"
                                lineHeight="1.2"
                                color="#455879"
                              >
                                {missionTypeStats.TAS.valeur}
                              </Text>
                            </Flex>
                          </Flex>
                          <VStack spacing="6px" align="flex-start" w="100%">
                            <Text
                              fontFamily="Poppins, sans-serif"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="1.2"
                              color="#656C7A"
                              textAlign="center"
                              w="100%"
                              whiteSpace="pre-wrap"
                            >
                              Ambulance Simple
                            </Text>
                            <Flex gap="10px" h="18px" alignItems="center" justifyContent="center" w="100%">
                              <Text
                                fontFamily="Poppins, sans-serif"
                                fontWeight="400"
                                fontSize="12px"
                                lineHeight="1.2"
                                color="#656C7A"
                              >
                                Aujourd'hui
                              </Text>
                              <Flex gap="5px" alignItems="center">
                                <Icon
                                  as={MdTrendingUp}
                                  w="12px"
                                  h="12px"
                                  color={missionTypeStats.TAS.evolution >= 0 ? "#29BACD" : "#F8285A"}
                                  transform={missionTypeStats.TAS.evolution < 0 ? "rotate(180deg)" : "none"}
                                />
                                <Text
                                  fontFamily="Poppins, sans-serif"
                                  fontWeight="500"
                                  fontSize="12px"
                                  lineHeight="12px"
                                  color={missionTypeStats.TAS.evolution >= 0 ? "#29BACD" : "#F8285A"}
                                >
                                  {missionTypeStats.TAS.evolution >= 0 ? "+" : ""}
                                  {missionTypeStats.TAS.evolution}% {getComparisonText(selectedPeriod)}
                                </Text>
                              </Flex>
                            </Flex>
                          </VStack>
                        </VStack>
                      </Box>
                      {/* Ambulance */}
                      <Box
                        flex="1"
                        bg="#FCFCFC"
                        p="20px"
                        pt="14px"
                        pb="20px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <VStack spacing="13px" align="center" w="169px">
                          <Flex w="100%" alignItems="flex-end" justifyContent="center">
                            <Flex flex="1" gap="10px" alignItems="center" justifyContent="center">
                              <Box
                                as="img"
                                src={ambulanceStatsImg || undefined}
                                alt="Ambulance"
                                w="32px"
                                h="32px"
                                objectFit="contain"
                              />
                              <Text
                                fontFamily="Oswald, sans-serif"
                                fontWeight="600"
                                fontSize="28px"
                                lineHeight="1.2"
                                color="#455879"
                              >
                                {missionTypeStats.TAR.valeur}
                              </Text>
                            </Flex>
                          </Flex>
                          <VStack spacing="6px" align="flex-start" w="100%">
                            <Text
                              fontFamily="Poppins, sans-serif"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="1.2"
                              color="#656C7A"
                              textAlign="center"
                              w="100%"
                              whiteSpace="pre-wrap"
                            >
                              Ambulance Réanimation
                            </Text>
                            <Flex gap="10px" h="18px" alignItems="center" justifyContent="center" w="100%">
                              <Text
                                fontFamily="Poppins, sans-serif"
                                fontWeight="400"
                                fontSize="12px"
                                lineHeight="1.2"
                                color="#656C7A"
                              >
                                Aujourd'hui
                              </Text>
                              <Flex gap="5px" alignItems="center">
                                <Icon
                                  as={MdTrendingUp}
                                  w="12px"
                                  h="12px"
                                  color={missionTypeStats.TAR.evolution >= 0 ? "#29BACD" : "#F8285A"}
                                  transform={missionTypeStats.TAR.evolution < 0 ? "rotate(180deg)" : "none"}
                                />
                                <Text
                                  fontFamily="Poppins, sans-serif"
                                  fontWeight="500"
                                  fontSize="12px"
                                  lineHeight="12px"
                                  color={missionTypeStats.TAR.evolution >= 0 ? "#29BACD" : "#F8285A"}
                                >
                                  {missionTypeStats.TAR.evolution >= 0 ? "+" : ""}
                                  {missionTypeStats.TAR.evolution}% {getComparisonText(selectedPeriod)}
                                </Text>
                              </Flex>
                            </Flex>
                          </VStack>
                        </VStack>
                      </Box>
                    </Flex>
                  </Box>

                  <VStack spacing="14px" align="stretch">
                    {/* Première rangée - Missions */}
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="14px">
                      {/* Appels Reçus Aujourd'hui */}
                      <Box
                        bg="white"
                        border="1px solid"
                        borderColor="#E5E5E5"
                        borderRadius="12px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      >
                        <Flex justify="space-between" align="flex-start" mb="10px">
                          <VStack align="flex-start" spacing="10px" flex={1}>
                            <Box
                              w="36px"
                              h="36px"
                              bg="#EFF6FF"
                              border="1px solid"
                              borderColor="rgba(69,156,233,0.2)"
                              borderRadius="6px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Image src={phoneIcon} w="20px" h="20px" />
                            </Box>
                            <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                              {getAppelsTitle(selectedPeriod)}
                            </Text>
                            <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                              {dashboardMetrics.appelsRecus.valeur || 0}
                            </Text>
                            <HStack spacing="10px" align="center" w="100%">
                              <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {getSinceText(selectedPeriod)}
                              </Text>
                              {dashboardMetrics.appelsRecus.differencePourcentage !== undefined && (
                                <Badge
                                  bg="#EAF8FA"
                                  border="1px solid"
                                  borderColor="rgba(41,186,205,0.2)"
                                  borderRadius="4px"
                                  px="3px"
                                  py="3px"
                                >
                                  <HStack spacing="5px">
                                    <Icon
                                      as={dashboardMetrics.appelsRecus.differencePourcentage >= 0 ? MdTrendingUp : MdTrendingUp}
                                      w="12px"
                                      h="12px"
                                      color={dashboardMetrics.appelsRecus.differencePourcentage >= 0 ? "#29BACD" : "#F8285A"}
                                      transform={dashboardMetrics.appelsRecus.differencePourcentage < 0 ? "rotate(180deg)" : "none"}
                                    />
                                    <Text fontSize="12px" color={dashboardMetrics.appelsRecus.differencePourcentage >= 0 ? "#29BACD" : "#F8285A"} fontWeight="500" fontFamily="Poppins, sans-serif">
                                      {formatEvolution(dashboardMetrics.appelsRecus.differencePourcentage).text} {getComparisonText(selectedPeriod)}
                                    </Text>
                                  </HStack>
                                </Badge>
                              )}
                            </HStack>
                          </VStack>
                          <Badge
                            bg="#FFEEF3"
                            border="1px solid"
                            borderColor="rgba(248,40,90,0.2)"
                            borderRadius="30px"
                            px="10px"
                            py="5px"
                          >
                            <HStack spacing="5px">
                              <Box
                                w="6px"
                                h="6px"
                                bg="#F8285A"
                                borderRadius="50%"
                                position="relative"
                              >
                                <Box
                                  position="absolute"
                                  top="50%"
                                  left="50%"
                                  transform="translate(-50%, -50%)"
                                  w="10px"
                                  h="10px"
                                  bg="rgba(248,40,90,0.2)"
                                  borderRadius="50%"
                                  animation="pulse 2s infinite"
                                />
                              </Box>
                              <Text fontSize="13px" color="#F8285A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                LIVE
                              </Text>
                            </HStack>
                          </Badge>
                        </Flex>
                      </Box>

                      {/* Missions en Cours */}
                      <Box
                        bg="white"
                        border="2px solid"
                        borderColor="rgba(246,177,0,0.2)"
                        borderRadius="12px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      >
                        <Flex justify="space-between" align="flex-start" mb="10px">
                          <VStack align="flex-start" spacing="10px" flex={1}>
                            <Box
                              w="36px"
                              h="36px"
                              bg="#FFF8DD"
                              border="1px solid"
                              borderColor="rgba(246,177,0,0.2)"
                              borderRadius="6px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Image src={pulseIcon} w="20px" h="20px" />
                            </Box>
                            <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                              Missions en Cours
                            </Text>
                            <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                              {dashboardMetrics.missionsEnCours.valeur || 0}
                            </Text>
                            <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                              Interventions actives
                            </Text>
                          </VStack>
                          <Badge
                            bg="#FFEEF3"
                            border="1px solid"
                            borderColor="rgba(248,40,90,0.2)"
                            borderRadius="30px"
                            px="10px"
                            py="5px"
                          >
                            <HStack spacing="5px">
                              <Box
                                w="6px"
                                h="6px"
                                bg="#F8285A"
                                borderRadius="50%"
                                position="relative"
                              >
                                <Box
                                  position="absolute"
                                  top="50%"
                                  left="50%"
                                  transform="translate(-50%, -50%)"
                                  w="10px"
                                  h="10px"
                                  bg="rgba(248,40,90,0.2)"
                                  borderRadius="50%"
                                  animation="pulse 2s infinite"
                                />
                              </Box>
                              <Text fontSize="13px" color="#F8285A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                LIVE
                              </Text>
                            </HStack>
                          </Badge>
                        </Flex>
                      </Box>

                      {/* Missions Terminées */}
                      <Box
                        bg="white"
                        border="2px solid"
                        borderColor="rgba(41,186,205,0.2)"
                        borderRadius="12px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      >
                        <Flex justify="space-between" align="flex-start" mb="10px">
                          <VStack align="flex-start" spacing="10px" flex={1}>
                            <Box
                              w="36px"
                              h="36px"
                              bg="#EAF8FA"
                              border="1px solid"
                              borderColor="rgba(41,186,205,0.2)"
                              borderRadius="6px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Image src={shieldTickIcon} w="20px" h="20px" />
                            </Box>
                            <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                              Missions Terminées
                            </Text>
                            <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                              {dashboardMetrics.missionsTerminees.valeur || 0}
                            </Text>
                            <HStack spacing="10px" align="center" w="100%">
                              <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {getPeriodLabel(selectedPeriod)}
                              </Text>
                              {dashboardMetrics.missionsTerminees.differencePourcentage !== undefined && (
                                <Badge
                                  bg="#EAF8FA"
                                  border="1px solid"
                                  borderColor="rgba(41,186,205,0.2)"
                                  borderRadius="4px"
                                  px="3px"
                                  py="3px"
                                >
                                  <HStack spacing="5px">
                                    <Icon
                                      as={MdTrendingUp}
                                      w="12px"
                                      h="12px"
                                      color={dashboardMetrics.missionsTerminees.differencePourcentage >= 0 ? "#29BACD" : "#F8285A"}
                                      transform={dashboardMetrics.missionsTerminees.differencePourcentage < 0 ? "rotate(180deg)" : "none"}
                                    />
                                    <Text fontSize="12px" color={dashboardMetrics.missionsTerminees.differencePourcentage >= 0 ? "#29BACD" : "#F8285A"} fontWeight="500" fontFamily="Poppins, sans-serif">
                                      {formatEvolution(dashboardMetrics.missionsTerminees.differencePourcentage).text} {getComparisonText(selectedPeriod)}
                                    </Text>
                                  </HStack>
                                </Badge>
                              )}
                            </HStack>
                          </VStack>
                          <Badge
                            bg="#FFEEF3"
                            border="1px solid"
                            borderColor="rgba(248,40,90,0.2)"
                            borderRadius="30px"
                            px="10px"
                            py="5px"
                          >
                            <HStack spacing="5px">
                              <Box
                                w="6px"
                                h="6px"
                                bg="#F8285A"
                                borderRadius="50%"
                                position="relative"
                              >
                                <Box
                                  position="absolute"
                                  top="50%"
                                  left="50%"
                                  transform="translate(-50%, -50%)"
                                  w="10px"
                                  h="10px"
                                  bg="rgba(248,40,90,0.2)"
                                  borderRadius="50%"
                                  animation="pulse 2s infinite"
                                />
                              </Box>
                              <Text fontSize="13px" color="#F8285A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                LIVE
                              </Text>
                            </HStack>
                          </Badge>
                        </Flex>
                      </Box>

                      {/* Missions Annulées */}
                      <Box
                        bg="white"
                        border="2px solid"
                        borderColor="rgba(248,40,90,0.2)"
                        borderRadius="12px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      >
                        <Flex justify="space-between" align="flex-start" mb="10px">
                          <VStack align="flex-start" spacing="10px" flex={1}>
                            <Box
                              w="36px"
                              h="36px"
                              bg="#FFEEF3"
                              border="1px solid"
                              borderColor="rgba(248,40,90,0.2)"
                              borderRadius="6px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Image src={crossCircleIcon} w="20px" h="20px" />
                            </Box>
                            <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                              Missions Annulées
                            </Text>
                            <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                              {String(dashboardMetrics.missionsAnnulees.valeur || 0).padStart(2, '0')}
                            </Text>
                            <HStack spacing="10px" align="center" w="100%">
                              <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {getPeriodLabel(selectedPeriod)}
                              </Text>
                              {dashboardMetrics.missionsAnnulees.differencePourcentage !== undefined && (
                                <Badge
                                  bg="#FFEEF3"
                                  border="1px solid"
                                  borderColor="rgba(248,40,90,0.2)"
                                  borderRadius="4px"
                                  px="3px"
                                  py="3px"
                                >
                                  <HStack spacing="5px">
                                    <Icon
                                      as={MdTrendingUp}
                                      w="12px"
                                      h="12px"
                                      color={dashboardMetrics.missionsAnnulees.differencePourcentage >= 0 ? "#F8285A" : "#29BACD"}
                                      transform={dashboardMetrics.missionsAnnulees.differencePourcentage < 0 ? "rotate(180deg)" : "none"}
                                    />
                                    <Text fontSize="12px" color={dashboardMetrics.missionsAnnulees.differencePourcentage >= 0 ? "#F8285A" : "#29BACD"} fontWeight="500" fontFamily="Poppins, sans-serif">
                                      {formatEvolution(dashboardMetrics.missionsAnnulees.differencePourcentage).text} {getComparisonText(selectedPeriod)}
                                    </Text>
                                  </HStack>
                                </Badge>
                              )}
                            </HStack>
                          </VStack>
                          <Badge
                            bg="#FFEEF3"
                            border="1px solid"
                            borderColor="rgba(248,40,90,0.2)"
                            borderRadius="30px"
                            px="10px"
                            py="5px"
                          >
                            <HStack spacing="5px">
                              <Box
                                w="6px"
                                h="6px"
                                bg="#F8285A"
                                borderRadius="50%"
                                position="relative"
                              >
                                <Box
                                  position="absolute"
                                  top="50%"
                                  left="50%"
                                  transform="translate(-50%, -50%)"
                                  w="10px"
                                  h="10px"
                                  bg="rgba(248,40,90,0.2)"
                                  borderRadius="50%"
                                  animation="pulse 2s infinite"
                                />
                              </Box>
                              <Text fontSize="13px" color="#F8285A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                LIVE
                              </Text>
                            </HStack>
                          </Badge>
                        </Flex>
                      </Box>
                    </SimpleGrid>

                    {/* Deuxième rangée - Délais */}
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="14px">
                      {/* Durée Totale Moyenne Mission */}
                      <Box
                        bg="white"
                        border="1px solid"
                        borderColor="#E5E5E5"
                        borderRadius="12px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      >
                        <VStack align="flex-start" spacing="10px">
                          <Box
                            w="36px"
                            h="36px"
                            bg="#EFF6FF"
                            border="1px solid"
                            borderColor="rgba(69,156,233,0.2)"
                            borderRadius="6px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Icon as={MdTimer} w="20px" h="20px" color="#459CE9" />
                          </Box>
                          <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                            Durée Totale Moyenne Mission
                          </Text>
                          <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                            {minutesToMMSS(dashboardMetrics.dureeTotaleMoyenneMission.valeur)}
                          </Text>
                          <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                            Minutes
                          </Text>
                        </VStack>
                      </Box>

                      {/* Délai Moyen d'Affectation */}
                      <Box
                        bg="white"
                        border="1px solid"
                        borderColor="#E5E5E5"
                        borderRadius="12px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      >
                        <VStack align="flex-start" spacing="10px">
                          <Box
                            w="36px"
                            h="36px"
                            bg="#EFF6FF"
                            border="1px solid"
                            borderColor="rgba(69,156,233,0.2)"
                            borderRadius="6px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Icon as={MdTimer} w="20px" h="20px" color="#459CE9" />
                          </Box>
                          <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                            Délai Moyen d'Affectation
                          </Text>
                          <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                            {minutesToMMSS(dashboardMetrics.delaiMoyenAffectation.valeur)}
                          </Text>
                          <Text fontSize="13px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                            Minutes (appel → dispatch)
                          </Text>
                        </VStack>
                      </Box>

                      {/* Délai Moyen Intervention */}
                      <Box
                        bg="white"
                        border="1px solid"
                        borderColor="#E5E5E5"
                        borderRadius="12px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      >
                        <Flex justify="space-between" align="flex-start" mb="10px">
                          <VStack align="flex-start" spacing="10px" flex={1}>
                            <Box
                              w="36px"
                              h="36px"
                              bg="#EFF6FF"
                              border="1px solid"
                              borderColor="rgba(69,156,233,0.2)"
                              borderRadius="6px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Icon as={MdAccessTime} w="20px" h="20px" color="#459CE9" />
                            </Box>
                            <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                              Délai Moyen Intervention
                            </Text>
                            <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                              {minutesToMMSS(dashboardMetrics.delaiMoyenIntervention.valeur)}
                            </Text>
                            <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                              Minutes
                            </Text>
                          </VStack>
                          <Badge
                            bg="#FFEEF3"
                            border="1px solid"
                            borderColor="rgba(248,40,90,0.2)"
                            borderRadius="30px"
                            px="10px"
                            py="5px"
                          >
                            <HStack spacing="5px">
                              <Box
                                w="6px"
                                h="6px"
                                bg="#F8285A"
                                borderRadius="50%"
                                position="relative"
                              >
                                <Box
                                  position="absolute"
                                  top="50%"
                                  left="50%"
                                  transform="translate(-50%, -50%)"
                                  w="10px"
                                  h="10px"
                                  bg="rgba(248,40,90,0.2)"
                                  borderRadius="50%"
                                  animation="pulse 2s infinite"
                                />
                              </Box>
                              <Text fontSize="13px" color="#F8285A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                LIVE
                              </Text>
                            </HStack>
                          </Badge>
                        </Flex>
                      </Box>

                      {/* Délai Moyen sur site */}
                      <Box
                        bg="white"
                        border="1px solid"
                        borderColor="#E5E5E5"
                        borderRadius="12px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      >
                        <VStack align="flex-start" spacing="10px">
                          <Box
                            w="36px"
                            h="36px"
                            bg="#FFF8DD"
                            border="1px solid"
                            borderColor="rgba(246,177,0,0.2)"
                            borderRadius="6px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Icon as={MdAccessTime} w="18px" h="18px" color="#F6B100" />
                          </Box>
                          <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                            Délai Moyen sur site
                          </Text>
                          <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                            {minutesToMMSS(dashboardMetrics.delaiMoyenSurSite.valeur)}
                          </Text>
                          <HStack spacing="10px" align="center" w="100%">
                            <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                              {getSinceText(selectedPeriod)}
                            </Text>
                            {dashboardMetrics.delaiMoyenSurSite.differencePourcentage !== undefined && (
                              <Badge
                                bg="#EAF8FA"
                                border="1px solid"
                                borderColor="rgba(41,186,205,0.2)"
                                borderRadius="4px"
                                px="3px"
                                py="3px"
                              >
                                <HStack spacing="5px">
                                  <Icon
                                    as={MdTrendingUp}
                                    w="12px"
                                    h="12px"
                                    color={dashboardMetrics.delaiMoyenSurSite.differencePourcentage >= 0 ? "#29BACD" : "#F8285A"}
                                    transform={dashboardMetrics.delaiMoyenSurSite.differencePourcentage < 0 ? "rotate(180deg)" : "none"}
                                  />
                                  <Text fontSize="12px" color={dashboardMetrics.delaiMoyenSurSite.differencePourcentage >= 0 ? "#29BACD" : "#F8285A"} fontWeight="500" fontFamily="Poppins, sans-serif">
                                    {formatEvolution(dashboardMetrics.delaiMoyenSurSite.differencePourcentage).text} {getComparisonText(selectedPeriod)}
                                  </Text>
                                </HStack>
                              </Badge>
                            )}
                          </HStack>
                        </VStack>
                      </Box>
                    </SimpleGrid>

                    {/* Troisième rangée - Cartes colorées */}
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing="14px">
                      {/* Taux Urgence Vitale */}
                      <Box
                        bg="#B62B301A"
                        borderRadius="12px"
                        border="#B62B3033 solid 1px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                        minH="178px"
                      >
                        <VStack align="flex-start" spacing="10px" color="#B62B30">
                          <Flex justify="space-between" align="center" w="100%">
                            <Text fontSize="14px" fontWeight="500" fontFamily="Poppins, sans-serif" flex={1}>
                              Taux Urgence
                            </Text>
                            <Box
                              w="36px"
                              h="36px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Image src={urgent} w="20px" h="20px" color="white" />
                            </Box>
                          </Flex>
                          <Text fontSize="28px" color="#B62B30" fontWeight="600" fontFamily="Oswald, sans-serif">
                            {urgenceData.tauxUrgence.find(u => u.type === 'Urgence vitale')?.pourcentage?.toFixed(0) || 0}%
                          </Text>
                          <HStack spacing="10px" flexWrap="wrap" color="#B62B30">
                            {urgenceData.tauxUrgence.map((urgence, idx) => {
                              const labelMap = {
                                'Urgence vitale': 'Vitale:',
                                'Urgence élevée': 'Élevée:',
                                'Non vitale': 'Non vitale:'
                              };
                              const label = labelMap[urgence.type] || urgence.type;
                              return (
                                <Badge
                                  key={idx}
                                  bg="#B62B301A"
                                  border="#B62B301A solid 1px"
                                  borderRadius="12px"
                                  px="5px"
                                  py="5px"
                                  color="#B62B30"
                                >
                                  <HStack spacing="5px" color="#B62B30"  >
                                    <Text fontSize="13px" fontWeight="500" fontFamily="Poppins, sans-serif">{label}</Text>
                                    <Text fontSize="16px" fontWeight="600" fontFamily="Poppins, sans-serif">{urgence.nombre || 0}</Text>
                                    <Text fontSize="13px" fontWeight="500" fontFamily="Poppins, sans-serif">-</Text>
                                    <Text fontSize="16px" fontWeight="600" fontFamily="Poppins, sans-serif">{urgence.pourcentage?.toFixed(0) || 0}%</Text>
                                  </HStack>
                                </Badge>
                              );
                            })}
                          </HStack>

                        </VStack>
                      </Box>

                      {/* Type d'Urgences (Top 3) */}
                      <Box
                        bg="#004AD21A"
                        borderRadius="12px"
                        border="#004AD21A solid 1px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                        minH="178px"
                      >
                        <VStack align="flex-start" spacing="10px" color="#004AD2">
                          <Flex justify="space-between" align="center" w="100%">
                            <Text fontSize="14px" fontWeight="500" fontFamily="Poppins, sans-serif" flex={1}>
                              Type d'Urgences (Top 3)
                            </Text>
                            <Box
                              w="36px"
                              h="36px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Image src={Type_urg} w="20px" h="20px" color="white" />
                            </Box>
                          </Flex>
                          <VStack align="flex-start" spacing="5px" w="100%">
                            {urgenceData.topCauses.slice(0, 3).map((cause, idx) => (
                              <Flex key={idx} justify="space-between" align="center" w="100%">
                                <Text fontSize="13px" fontWeight="500" fontFamily="Poppins, sans-serif">
                                  {cause.cause}
                                </Text>
                                <Text fontSize="16px" fontWeight="600" fontFamily="Poppins, sans-serif">
                                  {cause.pourcentage?.toFixed(0) || 0}%
                                </Text>
                              </Flex>
                            ))}
                            {urgenceData.topCauses.length === 0 && (
                              <>
                                <Flex justify="space-between" align="center" w="100%">
                                  <Text fontSize="13px" fontWeight="500" fontFamily="Poppins, sans-serif">
                                    Aucune donnée
                                  </Text>
                                  <Text fontSize="16px" fontWeight="600" fontFamily="Poppins, sans-serif">
                                    0%
                                  </Text>
                                </Flex>
                              </>
                            )}
                          </VStack>

                        </VStack>
                      </Box>

                      {/* Performance Globale */}
                      <Box
                        bg="#0061331A"
                        borderRadius="12px"
                        border="#00613333 solid 1px"
                        p="20px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                        minH="178px"
                      >
                        <VStack align="flex-start" spacing="10px" color="#006133" h="100%">
                          <Flex justify="space-between" align="center" w="100%">
                            <Text fontSize="14px" fontWeight="500" fontFamily="Poppins, sans-serif" flex={1}>
                              Performance Globale
                            </Text>
                            <Box
                              w="36px"
                              h="36px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Icon as={MdTrendingUp} w="20px" h="20px" color="white" />
                            </Box>
                          </Flex>
                          <Text fontSize="28px" fontWeight="600" fontFamily="Oswald, sans-serif">
                            {performanceData.tauxPerformanceGlobal.toFixed(2)}%
                          </Text>
                          <Text fontSize="13px" fontWeight="500" fontFamily="Poppins, sans-serif">
                            Objectif de performance atteint: 95%
                          </Text>
                        </VStack>
                      </Box>
                    </SimpleGrid>
                  </VStack>
                </VStack>
              </Card>

              {/* Section État Opérationnel */}
              <Card
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
              >
                <VStack spacing="20px" align="stretch">
                  {/* En-tête */}
                  <VStack spacing="5px" align="flex-start">
                    <Text fontSize="16px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                      État Opérationnel
                    </Text>
                    <Text fontSize="13px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                      Ressources disponibles et affectations en cours
                    </Text>
                  </VStack>

                  <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="14px">
                    {/* Ambulances */}
                    <Card
                      bg="white"
                      border="1px solid"
                      borderColor="#E5E5E5"
                      borderRadius="12px"
                      boxShadow="0px 4px 30px 0px rgba(0,0,0,0.06)"
                      overflow="hidden"
                      h="739px"
                      display="flex"
                      flexDirection="column"
                    >
                      <Box
                        bg="#FCFCFC"
                        borderBottom="1px solid #E5E5E5"
                        px="20px"
                        py="14px"
                      >
                        <HStack spacing="10px">
                          <Box
                            w="36px"
                            h="36px"
                            bg="#EFF6FF"
                            border="1px solid"
                            borderColor="rgba(69,156,233,0.2)"
                            borderRadius="6px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Icon as={MdOutlineFireTruck} w="19px" h="19px" color="#459CE9" />
                          </Box>
                          <VStack align="flex-start" spacing="5px">
                            <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                              Ambulances
                            </Text>
                            <Text fontSize="13px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                              Flotte totale: <Text as="span" fontWeight="700">{ambulancesData.total || 0}</Text> véhicules
                            </Text>
                          </VStack>
                        </HStack>
                      </Box>
                      <VStack spacing="10px" p="14px" align="stretch" flex="1" overflow="hidden">
                        <SimpleGrid columns={3} spacing="10px">
                          <Box
                            bg={ambulanceFilter === 'disponibles' ? '#EAF8FA' : '#EAF8FA'}
                            border={ambulanceFilter === 'disponibles' ? '2px solid #29BACD' : '1px solid rgba(41,186,205,0.2)'}
                            borderRadius="12px"
                            p="10px"
                            cursor="pointer"
                            transition="all 0.2s"
                            opacity={ambulanceFilter !== 'tous' && ambulanceFilter !== 'disponibles' ? 0.6 : 1}
                            _hover={{
                              transform: 'scale(1.02)',
                              boxShadow: '0px 4px 12px rgba(41,186,205,0.2)',
                              opacity: 1
                            }}
                            onClick={() => setAmbulanceFilter(ambulanceFilter === 'disponibles' ? 'tous' : 'disponibles')}
                          >
                            <VStack align="flex-start" spacing="10px">
                              <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                                Disponibles
                              </Text>
                              <Text fontSize="20px" color="#29BACD" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {ambulancesData.ambulances.filter(amb => amb.statut === 'disponible').length}
                              </Text>
                            </VStack>
                          </Box>
                          <Box
                            bg={ambulanceFilter === 'intervention' ? '#FFF8DD' : '#FFF8DD'}
                            border={ambulanceFilter === 'intervention' ? '2px solid #F6B100' : '1px solid #E5E5E5'}
                            borderRadius="12px"
                            p="10px"
                            cursor="pointer"
                            transition="all 0.2s"
                            opacity={ambulanceFilter !== 'tous' && ambulanceFilter !== 'intervention' ? 0.6 : 1}
                            _hover={{
                              transform: 'scale(1.02)',
                              boxShadow: '0px 4px 12px rgba(246,177,0,0.2)',
                              opacity: 1
                            }}
                            onClick={() => setAmbulanceFilter(ambulanceFilter === 'intervention' ? 'tous' : 'intervention')}
                          >
                            <VStack align="flex-start" spacing="10px">
                              <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                                En intervention
                              </Text>
                              <Text fontSize="20px" color="#F6B100" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {ambulancesData.ambulances.filter(amb => amb.statut === 'en mission').length}
                              </Text>
                            </VStack>
                          </Box>
                          <Box
                            bg={ambulanceFilter === 'maintenance' ? '#F9F9F9' : '#F9F9F9'}
                            border={ambulanceFilter === 'maintenance' ? '2px solid #656C7A' : '1px solid #E5E5E5'}
                            borderRadius="12px"
                            p="10px"
                            cursor="pointer"
                            transition="all 0.2s"
                            opacity={ambulanceFilter !== 'tous' && ambulanceFilter !== 'maintenance' ? 0.6 : 1}
                            _hover={{
                              transform: 'scale(1.02)',
                              boxShadow: '0px 4px 12px rgba(101,108,122,0.2)',
                              opacity: 1
                            }}
                            onClick={() => setAmbulanceFilter(ambulanceFilter === 'maintenance' ? 'tous' : 'maintenance')}
                          >
                            <VStack align="flex-start" spacing="10px">
                              <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                                En maintenance
                              </Text>
                              <Text fontSize="20px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {ambulancesData.ambulances.filter(amb => amb.statut === 'entretien').length}
                              </Text>
                            </VStack>
                          </Box>
                        </SimpleGrid>

                        {/* Liste des ambulances - Données statiques avec filtrage - Scrollable */}
                        <Box
                          flex="1"
                          overflowY="auto"
                          minH="0"
                          pr="5px"
                          css={{
                            '&::-webkit-scrollbar': {
                              width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                              background: '#f1f1f1',
                              borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              background: '#888',
                              borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              background: '#555',
                            },
                          }}
                        >
                          <VStack spacing="10px" align="stretch">
                            {ambulancesData.ambulances.length === 0 ? (
                              <Box
                                bg="#FCFCFC"
                                border="1px solid #E5E5E5"
                                borderRadius="12px"
                                p="20px"
                                textAlign="center"
                              >
                                <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                                  Aucune ambulance disponible
                                </Text>
                              </Box>
                            ) : (
                              ambulancesData.ambulances
                                .filter(amb => {
                                  if (ambulanceFilter === 'tous') return true;
                                  if (ambulanceFilter === 'disponibles') return amb.statut === 'disponible';
                                  if (ambulanceFilter === 'intervention') return amb.statut === 'en mission';
                                  if (ambulanceFilter === 'maintenance') return amb.statut === 'entretien';
                                  return true;
                                })
                                .map((amb, idx) => {
                                  // Déterminer la couleur du point selon le statut (même couleur que les cartes)
                                  const getPointColor = () => {
                                    if (amb.statut === 'disponible') return '#29BACD';
                                    if (amb.statut === 'en mission') return '#F6B100';
                                    if (amb.statut === 'entretien') return '#656C7A';
                                    return '#29BACD'; // Par défaut
                                  };
                                  const pointColor = getPointColor();

                                  // Formater le statut pour l'affichage
                                  const getStatutLabel = () => {
                                    if (amb.statut === 'disponible') return 'Disponible';
                                    if (amb.statut === 'en mission') return 'En intervention';
                                    if (amb.statut === 'entretien') return 'En maintenance';
                                    return amb.statut;
                                  };

                                  return (
                                    <Box
                                      key={amb.id || idx}
                                      bg="#FCFCFC"
                                      border="1px solid #E5E5E5"
                                      borderRadius="12px"
                                      p="14px"
                                      boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                                    >
                                      <VStack spacing="5px" align="stretch">
                                        <Flex justify="space-between" align="flex-start">
                                          <HStack spacing="10px">
                                            <Box
                                              w="36px"
                                              h="36px"
                                              bg={amb.statut === 'disponible' ? 'white' : '#EFF6FF'}
                                              border="1px solid"
                                              borderColor={amb.statut === 'disponible' ? '#E5E5E5' : 'rgba(69,156,233,0.2)'}
                                              borderRadius="6px"
                                              display="flex"
                                              alignItems="center"
                                              justifyContent="center"
                                            >
                                              <Icon as={MdOutlineFireTruck} w="19px" h="19px" color="#459CE9" />
                                            </Box>
                                            <VStack align="flex-start" spacing="5px">
                                              <HStack spacing="5px">
                                                <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                                                  {amb.immatriculation}
                                                </Text>
                                                <Box
                                                  w="6px"
                                                  h="6px"
                                                  bg={pointColor}
                                                  borderRadius="50%"
                                                  position="relative"
                                                >
                                                  {amb.statut !== 'disponible' && (
                                                    <Box
                                                      position="absolute"
                                                      top="50%"
                                                      left="50%"
                                                      transform="translate(-50%, -50%)"
                                                      w="10px"
                                                      h="10px"
                                                      bg={`${pointColor}33`}
                                                      borderRadius="50%"
                                                      animation="pulse 2s infinite"
                                                    />
                                                  )}
                                                </Box>
                                              </HStack>
                                              <Text fontSize="12px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                                                {getStatutLabel()}
                                              </Text>
                                            </VStack>
                                          </HStack>
                                          {amb.mission && amb.mission.cause && (
                                            <Badge
                                              bg="#EFF6FF"
                                              border="1px solid"
                                              borderColor="rgba(69,156,233,0.2)"
                                              borderRadius="100px"
                                              px="10px"
                                              py="5px"
                                            >
                                              <Text fontSize="11px" color="#459CE9" fontWeight="500" fontFamily="Poppins, sans-serif">
                                                {amb.mission.cause}
                                              </Text>
                                            </Badge>
                                          )}
                                        </Flex>
                                        <HStack spacing="5px" flexWrap="wrap">
                                          {amb.mission && amb.mission.adresse && (
                                            <Badge
                                              bg="#F9F9F9"
                                              borderRadius="4px"
                                              px="8px"
                                              py="8px"
                                            >
                                              <HStack spacing="5px">
                                                <Icon as={MdRoute} w="14px" h="14px" color="#171D28" />
                                                <Text fontSize="14px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                                                  {amb.mission.adresse}
                                                </Text>
                                              </HStack>
                                            </Badge>
                                          )}
                                          {amb.ambulancier && (
                                            <Badge
                                              bg="#F9F9F9"
                                              borderRadius="4px"
                                              px="8px"
                                              py="8px"
                                            >
                                              <HStack spacing="5px">
                                                {amb.ambulancier.photo ? (
                                                  <Box
                                                    as="img"
                                                    src={amb.ambulancier.photo}
                                                    alt={`${amb.ambulancier.nom} ${amb.ambulancier.prenom}`}
                                                    w="20px"
                                                    h="20px"
                                                    borderRadius="3px"
                                                    objectFit="cover"
                                                  />
                                                ) : (
                                                  <Box
                                                    w="20px"
                                                    h="20px"
                                                    border="1px solid #E5E5E5"
                                                    borderRadius="3px"
                                                    bg="#F9F9F9"
                                                  />
                                                )}
                                                <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                                                  {amb.ambulancier.prenom} {amb.ambulancier.nom}
                                                </Text>
                                              </HStack>
                                            </Badge>
                                          )}
                                        </HStack>
                                      </VStack>
                                    </Box>
                                  );
                                })
                            )}
                          </VStack>
                        </Box>
                      </VStack>
                    </Card>

                    {/* Équipes Médicales */}
                    <Card
                      bg="white"
                      border="1px solid"
                      borderColor="#E5E5E5"
                      borderRadius="12px"
                      boxShadow="0px 4px 30px 0px rgba(0,0,0,0.06)"
                      overflow="hidden"
                      h="739px"
                      display="flex"
                      flexDirection="column"
                    >
                      <Box
                        bg="#FCFCFC"
                        borderBottom="1px solid #E5E5E5"
                        px="20px"
                        py="14px"
                      >
                        <HStack spacing="10px">
                          <Box
                            w="36px"
                            h="36px"
                            bg="#EFF6FF"
                            border="1px solid"
                            borderColor="rgba(69,156,233,0.2)"
                            borderRadius="6px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Icon as={MdOutlineMedicalServices} w="20px" h="20px" color="#459CE9" />
                          </Box>
                          <VStack align="flex-start" spacing="5px">
                            <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                              Équipes Médicales
                            </Text>
                            <Text fontSize="13px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                              Personnel en service
                            </Text>
                          </VStack>
                        </HStack>
                      </Box>
                      <VStack spacing="10px" p="14px" align="stretch" flex="1" overflow="hidden">
                        <SimpleGrid columns={3} spacing="10px">
                          <Box
                            bg={equipeFilter === 'medecins' ? '#EFF6FF' : '#EFF6FF'}
                            border={equipeFilter === 'medecins' ? '2px solid #459CE9' : '1px solid rgba(69,156,233,0.2)'}
                            borderRadius="12px"
                            p="10px"
                            cursor="pointer"
                            transition="all 0.2s"
                            opacity={equipeFilter !== 'tous' && equipeFilter !== 'medecins' && equipeFilter !== 'disponibles' && equipeFilter !== 'intervention' ? 0.6 : 1}
                            _hover={{
                              transform: 'scale(1.02)',
                              boxShadow: '0px 4px 12px rgba(69,156,233,0.2)',
                              opacity: 1
                            }}
                            onClick={() => setEquipeFilter(equipeFilter === 'medecins' ? 'tous' : 'medecins')}
                          >
                            <VStack align="flex-start" spacing="10px">
                              <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                                Médecins Urgentistes
                              </Text>
                              <Text fontSize="20px" color="#459CE9" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {equipeMedicaleData.medecins.total || 0}
                              </Text>
                              <Text fontSize="13px" color="#459CE9" fontWeight="400" fontFamily="Poppins, sans-serif">
                                {equipeMedicaleData.medecins.liste.length || 0} en service
                              </Text>
                            </VStack>
                          </Box>
                          <Box
                            bg={equipeFilter === 'infirmiers' ? '#EAF8FA' : '#EAF8FA'}
                            border={equipeFilter === 'infirmiers' ? '2px solid #29BACD' : '1px solid rgba(41,186,205,0.2)'}
                            borderRadius="12px"
                            p="10px"
                            cursor="pointer"
                            transition="all 0.2s"
                            opacity={equipeFilter !== 'tous' && equipeFilter !== 'infirmiers' && equipeFilter !== 'disponibles' && equipeFilter !== 'intervention' ? 0.6 : 1}
                            _hover={{
                              transform: 'scale(1.02)',
                              boxShadow: '0px 4px 12px rgba(41,186,205,0.2)',
                              opacity: 1
                            }}
                            onClick={() => setEquipeFilter(equipeFilter === 'infirmiers' ? 'tous' : 'infirmiers')}
                          >
                            <VStack align="flex-start" spacing="10px">
                              <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                                Infirmiers
                              </Text>
                              <Text fontSize="20px" color="#29BACD" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {equipeMedicaleData.infirmiers.total || 0}
                              </Text>
                              <Text fontSize="13px" color="#29BACD" fontWeight="400" fontFamily="Poppins, sans-serif">
                                {equipeMedicaleData.infirmiers.liste.length || 0} en service
                              </Text>
                            </VStack>
                          </Box>
                          <Box
                            bg={equipeFilter === 'ambulanciers' ? '#FFEEF3' : '#FFEEF3'}
                            border={equipeFilter === 'ambulanciers' ? '2px solid #F8285A' : '1px solid rgba(248,40,90,0.2)'}
                            borderRadius="12px"
                            p="10px"
                            cursor="pointer"
                            transition="all 0.2s"
                            opacity={equipeFilter !== 'tous' && equipeFilter !== 'ambulanciers' && equipeFilter !== 'disponibles' && equipeFilter !== 'intervention' ? 0.6 : 1}
                            _hover={{
                              transform: 'scale(1.02)',
                              boxShadow: '0px 4px 12px rgba(248,40,90,0.2)',
                              opacity: 1
                            }}
                            onClick={() => setEquipeFilter(equipeFilter === 'ambulanciers' ? 'tous' : 'ambulanciers')}
                          >
                            <VStack align="flex-start" spacing="10px">
                              <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                                Ambulanciers
                              </Text>
                              <Text fontSize="20px" color="#F8285A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                {equipeMedicaleData.ambulanciers.total || 0}
                              </Text>
                              <Text fontSize="13px" color="#F8285A" fontWeight="400" fontFamily="Poppins, sans-serif">
                                {equipeMedicaleData.ambulanciers.liste.length || 0} en service
                              </Text>
                            </VStack>
                          </Box>
                        </SimpleGrid>

                        {/* Liste du personnel - Données statiques avec filtrage - Scrollable */}
                        <Box
                          flex="1"
                          overflowY="auto"
                          minH="0"
                          pr="5px"
                          css={{
                            '&::-webkit-scrollbar': {
                              width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                              background: '#f1f1f1',
                              borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              background: '#888',
                              borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              background: '#555',
                            },
                          }}
                        >
                          <VStack spacing="10px" align="stretch">
                            {(() => {
                              // Combiner médecins, infirmiers et ambulanciers avec leurs rôles
                              const medecins = (equipeMedicaleData.medecins.liste || [])
                                .map(med => ({
                                  ...med,
                                  role: 'Médecin',
                                  roleLabel: 'Médecin'
                                }))
                                .sort((a, b) => (b.nombreMissions || 0) - (a.nombreMissions || 0)); // Tri par nombre de missions décroissant
                              const infirmiers = (equipeMedicaleData.infirmiers.liste || []).map(inf => ({
                                ...inf,
                                role: 'Infirmier',
                                roleLabel: 'Infirmier'
                              }));
                              const ambulanciers = (equipeMedicaleData.ambulanciers.liste || []).map(amb => ({
                                ...amb,
                                role: 'Ambulancier',
                                roleLabel: 'Ambulancier'
                              }));
                              const allPersonnel = [...medecins, ...infirmiers, ...ambulanciers];

                              // Filtrer selon le filtre actif
                              const filteredPersonnel = allPersonnel.filter(person => {
                                if (equipeFilter === 'tous') return true;
                                if (equipeFilter === 'medecins') return person.role === 'Médecin';
                                if (equipeFilter === 'infirmiers') return person.role === 'Infirmier';
                                if (equipeFilter === 'ambulanciers') return person.role === 'Ambulancier';
                                return true;
                              });

                              if (filteredPersonnel.length === 0) {
                                return (
                                  <Box
                                    bg="#FCFCFC"
                                    border="1px solid #E5E5E5"
                                    borderRadius="12px"
                                    p="20px"
                                    textAlign="center"
                                  >
                                    <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                                      Aucun personnel disponible
                                    </Text>
                                  </Box>
                                );
                              }

                              return filteredPersonnel.map((person, idx) => (
                                <Box
                                  key={person.id || idx}
                                  bg="#FCFCFC"
                                  border="1px solid #E5E5E5"
                                  borderRadius="12px"
                                  p="14px"
                                  boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                                >
                                  <Flex justify="space-between" align="flex-start">
                                    <HStack spacing="10px">
                                      {person.photo ? (
                                        <Box
                                          as="img"
                                          src={person.photo}
                                          alt={`${person.prenom} ${person.nom}`}
                                          w="40px"
                                          h="40px"
                                          borderRadius="6px"
                                          objectFit="cover"
                                          border="1px solid #E5E5E5"
                                        />
                                      ) : (
                                        <Box
                                          w="40px"
                                          h="40px"
                                          border="1px solid #E5E5E5"
                                          borderRadius="6px"
                                          bg="#F9F9F9"
                                        />
                                      )}
                                      <VStack align="flex-start" spacing="5px">
                                        <HStack spacing="5px">
                                          <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                                            {person.role === 'Médecin' ? 'Dr. ' : ''}{person.prenom} {person.nom}
                                          </Text>
                                        </HStack>
                                        <HStack spacing="7px">
                                          <Text fontSize="14px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                            {person.roleLabel}
                                          </Text>
                                          {person.specialite && (
                                            <>
                                              <Text fontSize="14px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                                •
                                              </Text>
                                              <Text fontSize="14px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                                                {person.specialite}
                                              </Text>
                                            </>
                                          )}
                                        </HStack>
                                      </VStack>
                                    </HStack>
                                    <Badge
                                      bg="white"
                                      border="1px solid #E5E5E5"
                                      borderRadius="100px"
                                      px="10px"
                                      py="5px"
                                    >
                                      <Text fontSize="11px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                                        {person.nombreMissions || 0} {person.nombreMissions === 1 ? 'mission' : 'missions'}
                                      </Text>
                                    </Badge>
                                  </Flex>
                                </Box>
                              ));
                            })()}
                          </VStack>
                        </Box>
                      </VStack>
                    </Card>
                  </SimpleGrid>
                </VStack>
              </Card>

            </VStack>
          </Box>
        </Box>
      </>
    )
  );
}
